<template>
    <main class="pd-main">
        <div class="main-content">
            <circle-spin class="m-0" v-if="loading"></circle-spin>
            <div class="row" v-else>
                <div class="col-xl-7">
                    <div class="card">
                        <h4 class="card-title text-uppercase header-bar">
                            <strong>My Profile</strong>
                            <ul class="topbar-btns">
                                <li class="dropdown">
                                    <a href="#" data-toggle="dropdown">
                                        <i class="ion-android-more-vertical"></i>
                                    </a>
                                    <div class="dropdown-menu dropdown-menu-right">
                                        <router-link to="/listener/edit-profile" tag="a" class="dropdown-item">
                                            Edit Profile
                                        </router-link>
                                        <div class="dropdown-divider"></div>
                                        <a href="#" @click="changePassword" class="modal-trigger dropdown-item">Change Password</a>
                                    </div>
                                    
                                </li>
                            </ul>
                        </h4>
                        <div class="card-body">
                            <div class="text-center">
                                <div class="avatar avatar-xxl" :class="userDetails.isOnline ? 'status-success' : null">
                                    <img v-if="listenerDetails.avatar == null" src="../../assets/static/img/avatar.jpg">
                                    <img v-else :src="listenerDetails.avatars[0].secure_url">
                                </div>
                                <h4 class="mb-0 text-capitalize">{{userDetails.firstname}} {{userDetails.lastname}}</h4>
                                <p class="text-primary ">@{{userDetails.nickname}}</p>
                            </div>
                        
                            <div>
                                <ul class="nav nav-tabs nav-justified">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#basic-details">Basic Information</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#other">Other Information</a>
                                    </li>
                                </ul>
                                <div class="tab-content">
                                    <div class="tab-pane active" id="basic-details">
                                                <div class="form-group row mb-0">
                                                    <label class="col-4 col-form-label">First Name:</label>
                                                    <div class="col-8">
                                                        <p class="form-control-plaintext text-capitalize">{{userDetails.firstname}}</p>
                                                    </div>
                                                </div>
                                                <div class="form-group row mb-0">
                                                    <label class="col-4 col-form-label">Last Name:</label>
                                                    <div class="col-8">
                                                        <p class="form-control-plaintext text-capitalize">{{userDetails.lastname}}</p>
                                                    </div>
                                                </div>
                                                <div class="form-group row mb-0">
                                                    <label class="col-4 col-form-label">Nickname:</label>
                                                    <div class="col-8">
                                                        <p class="form-control-plaintext">{{userDetails.nickname}}</p>
                                                    </div>
                                                </div>
                                                <div class="form-group row mb-0">
                                                    <label class="col-4 col-form-label">Email:</label>
                                                    <div class="col-8">
                                                        <p class="form-control-plaintext">{{userDetails.email}}</p>
                                                    </div>
                                                </div>
                                        
                                    </div>
                                    <div class="tab-pane" id="other">
                                                <div class="form-group row mb-0">
                                                    <label class="col-4 col-form-label">Gender:</label>
                                                    <div class="col-8">
                                                        <p class="form-control-plaintext">{{userDetails.gender}}</p>
                                                    </div>
                                                </div>
                                                <div class="form-group row mb-0">
                                                    <label class="col-4 col-form-label">Phone Number:</label>
                                                    <div class="col-8">
                                                        <p class="form-control-plaintext">{{userDetails.phone}}</p>
                                                    </div>
                                                </div>
                                                <div class="form-group row mb-0">
                                                    <label class="col-4 col-form-label">Birth Month:</label>
                                                    <div class="col-8">
                                                        <p class="form-control-plaintext">{{listenerDetails.birthmonth}}</p>
                                                    </div>
                                                </div>
                                                <div class="form-group row mb-0">
                                                    <label class="col-4 col-form-label">Birth Year:</label>
                                                    <div class="col-8">
                                                        <p class="form-control-plaintext">{{listenerDetails.birthyear}}</p>
                                                    </div>
                                                </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>    
                </div>
                <div class="col-xl-5">
                    <div class="callout callout-custom" role="alert">
                        <h5 class="text-uppercase no-padding"><strong>Support Issues</strong></h5>
                        <div class="mt-20">
                            <span :class="(i%2)==1? 'bg-2': 'bg-1'" class="badge mb-10 mr-10 badge-lg" v-for="(issue, i) in listenerDetails.Issues" :key="issue.title">{{issue.title}}</span>
                        </div>
                    </div>
                    <div class="callout callout-custom" role="alert">
                        <h5 class="text-uppercase no-padding"><strong>Known Languages</strong></h5>
                        <div class="mt-20">
                            <span :class="(i%2)==1? 'bg-1': 'bg-2'" class="badge mb-10 mr-10 badge-lg" v-for="(language, i) in listenerDetails.Languages" :key="language.name">{{language.name}}</span>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Modal for change password -->
            <modal name="change-password" height="auto" class="modal-container" :clickToClose="false">
                <div class="modal-content">
                <div class="boxed boxed--border">
                    <header class="no-border">
                    <div class="header-bar flexbox pl-20 justify-content-between">
                        <h5>
                        Change Password
                        </h5>
                        <span class="close" @click="hideModal($modal)" aria-label="Close" data-dismiss="close"><i class="ion-close-round"></i></span>
                    </div>
                    </header>
                    <div class="card-body">
                            <form>
                                <div class="form-group">
                                    <label for="old_password">Current Password</label>
                                    <input type="password" class="form-control py-10" v-model="old_password"  id="old_password">
                                    
                                </div>
                                <div class="form-group">
                                    <label for="new_password">New Password</label>
                                    <input type="password" class="form-control py-10" v-model="new_password"  @blur="$v.new_password.$touch()"  id="new_password">
                                    <div v-if="$v.new_password.$dirty">
                                        <div class="custom-error" v-if="!$v.new_password.required">*Please enter your password.</div>
                                        <div class="custom-error" v-if="!$v.new_password.minLength">*Password must be at least 8 digits.</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <label for="new_password">Confirm New Password</label>
                                    <input type="password" class="form-control py-10" v-model="confirm_password"  @blur="$v.confirm_password.$touch()" id="confirm_password">
                                    <div v-if="$v.confirm_password.$dirty">
                                        <div class="custom-error" v-if="!$v.confirm_password.sameAsPassword">*New password does not match.</div>
                                    </div>
                                </div>
                                <button class="btn btn-bold btn-sm btn-primary" disabled v-if="load_change">
                                    <circle-spin class="m-0"></circle-spin>
                                </button>
                                <button class="btn btn-bold btn-sm btn-primary" v-else :disabled="$v.$invalid"  @click="savePassword" type="button">Save</button>
                            </form>
                        </div>
                    
                </div>
                </div>
            </modal>
        </div>
    </main>
</template>

<script>
import axios from 'axios'
import allMixins from '../../mixins.js'
import {required, minLength, sameAs } from "vuelidate/lib/validators";

export default {
    name: "profileListener",
    mixins: [allMixins],
    data() {
        return {
            loading: true,
            load_change: false,
            userDetails: {},
            listenerDetails: {},
            old_password: "",
            new_password: "",
            confirm_password: ""
        }
    },
    validations: {
        new_password: {
            required,
            minLength: minLength(8),
        },
        confirm_password: {
        sameAsPassword: sameAs("new_password")
        }
    },
    methods: {
        // Filter even-indexed values and odd-indexed values
        even(value) {
            return value.filter( datum => {return value.indexOf(datum) % 2 == 0})
        },
        odd(value) {
            return value.filter(datum => {return value.indexOf(datum) % 2 != 0})
        },
        changePassword() {
            this.$modal.show("change-password");
        },
        hideModal(a) {
            this.old_password = ""
            this.new_password = ""
            this.confirm_password = ""
            this.$v.$reset()
            a.hide('change-password')
        },
        savePassword() {
            this.load_change = true
            let userData = {
                currentPassword: this.old_password,
                newPassword: this.new_password
            }
            axios.patch('/users/update/password', userData)
            .then(res => {
                this.load_change = false
                this.$notify({
                    group: 'response',
                    type: 'success',
                    text: `${res.data.data}`,
                    duration: 2500,
                })
                setTimeout(() => {
                    location.reload()
                }, 3000)
            })
            .catch(err => {
                this.load_change= false
                this.$notify({
                    group: 'response',
                    type: 'error',
                    text: `${err.response.data.message}`,
                    duration: 5000,
                });
            })
        }
    },
    mounted() {
        let details = this.$jwt.decode(this.retrieveToken(window.btoa('userToken')), "inGXVHWPU9BB5q2oix1r-zaA")

        axios.get(`users/find/${details.id}`)
        .then(res => {
            this.loading = false
            this.userDetails = res.data.user_details
            this.listenerDetails = res.data.listener[0]
        })
        .catch(err => {
            this.loading = false
            this.$notify({
            group: 'response',
            type: 'error',
            text:  `${err.response.data.message}`,
            duration: 5000
            });
        })
    },

}
</script>